<div id="errorBG" [ngClass]="modalClass">
    @if (error) {
        <div class="errorTile modalTile">
            <!-- Schliessen Button -->
            <div class="closeMe" (click)="close()" title="{{ txtClose }}"></div>
            <!-- Ueberschrift -->
            <div class="headline">
                {{ error.headline }}
            </div>
            <div class="warning">
                <div class="warningIconWrapper">
                    @switch (error.severity) {
                        <!-- Icons der Warnungen -->
                        @case (0) {
                            <div class="ic"><i class="icon ico-info">&#160;</i></div>
                        }
                        @case (1) {
                            <div class="ic"><i class="icon ico-warning">&#160;</i></div>
                        }
                        @case (2) {
                            <div class="ic"><i class="icon ico-close">&#160;</i></div>
                        }
                        @case (3) {
                            <div class="ic"><i class="ico-unwetter icon">&#160;</i></div>
                        }
                    }
                </div>
                <div class="warningMessageWrapper">
                    <!-- Inhalt -->
                    @for (detail of error.details; track detail) {
                        <div>{{ detail }}</div>
                    }
                    <div style="font-size: 0.8rem; line-height: 1.5; margin-top: 1rem;">
                        <div style="font-weight: bold">Technische Fehlerinformationen:&nbsp;
                            @if (false) {
                                <elem-tooltip
                                    text="Falls Sie diesen Fehler an die VHV melden wollen, schicken Sie bitte die nachfolgenden Fehlerinformationen mit. Damit ermöglichen Sie uns eine schnellere Bearbeitung."></elem-tooltip>
                            }
                            @if (false) {
                                <elem-button
                                    buttonRole="SMALL"
                                    icon="icon-duplicate"
                                    style="height: 25px; margin-left: 1rem"
                                    (click)="copyErrorInfo()">Kopieren
                                </elem-button>
                            }
                        </div>
                        @if (errorCorrelationId) {
                            <div>Fehler-ID: {{ errorCorrelationId }}</div>
                        }
                        @if (error.httpResponse) {
                            <div>Status: {{ error.httpResponse.status }}</div>
                        }
                        @if (timestamp) {
                            <div>Zeitstempel: {{ timestamp }}</div>
                        }
                        @if (userAgent) {
                            <div>Browser: {{ userAgent }}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</div>
